import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    resetPageState,
    resetAllData,
    updateCurPageData, 
    setCurPageIsError,
    updatePaymentData,
    updateLoginData,
    updateTransactionData,
    setMaxLoginTriesReached,
    setMax2FATriesReached,
    setPaymentError,
    setMaxResendOTPReached,
    setDefaultError,
    set2FAviaOTP,
    userTriggeredLeave,
    setStopQueryPolling,
    setIsLoading,
    setIsVerifying,
    setSessionExpired,
    setIsGuest,
    setIsSkipLogin,
    updateTopUpData
} from '../../actions';


function connectPage(WrappedComponent) {
    class MainWrapper extends Component {
        constructor(props) {
            super(props);
            this.component = React.createRef();
        }

        componentDidMount() {
            const { updateCurPageData } = this.props;
            updateCurPageData(this.component.current.pageName);
        }

        changePageHandler = (data) => {
            const { updateCurPageData } = this.props;
            updateCurPageData(data);
        }

        render() {
            const {
                dispatch,
                updatePaymentData,
                updateLoginData,
                updateTransactionData,
                setCurPageIsError,
                setMaxLoginTriesReached,
                setMax2FATriesReached,
                setPaymentError,
                setMaxResendOTPReached,
                set2FAviaOTP,
                setDefaultError,
                resetAllData,
                userTriggeredLeave,
                setStopQueryPolling,
                setIsLoading,
                setIsVerifying,
                setSessionExpired,
                setIsGuest,
                setIsSkipLogin,
                updateTopUpData,
            } = this.props;

            return (
                <React.Fragment>
                    <WrappedComponent
                        ref={this.component}
                        mainProps={this.props}
                        actionHandler={{
                            changePageHandler: this.changePageHandler,
                            dispatch,
                            updateLoginData,
                            updatePaymentData,
                            updateTransactionData,
                            setCurPageIsError,
                            setMaxLoginTriesReached,
                            setMax2FATriesReached,
                            setPaymentError,
                            setMaxResendOTPReached,
                            set2FAviaOTP,
                            setDefaultError,
                            resetAllData,
                            userTriggeredLeave,
                            setStopQueryPolling,
                            setIsLoading,
                            setIsVerifying,
                            setSessionExpired,
                            setIsGuest,
                            setIsSkipLogin,
                            updateTopUpData
                        }}
                    />
                </React.Fragment>
            );
        }
    }

    const mapStateToProps = (state) => {
        return ({
            appState: state.app.appState,
        })
    };

    const mapDispatchToProps = (dispatch) => ({
        dispatch,
        updateCurPageData: (data) => dispatch(updateCurPageData(data)),
        resetPageState: () => dispatch(resetPageState()),
        setCurPageIsError: (data) => dispatch(setCurPageIsError(data)),
        updateLoginData: (data) => dispatch(updateLoginData(data)),
        updatePaymentData: (data) => dispatch(updatePaymentData(data)),
        updateTransactionData: (data) => dispatch(updateTransactionData(data)),
        setMaxLoginTriesReached: (data) => dispatch(setMaxLoginTriesReached(data)),
        setMax2FATriesReached: (data) => dispatch(setMax2FATriesReached(data)),
        setPaymentError: (data) => dispatch(setPaymentError(data)),
        setMaxResendOTPReached: (data) => dispatch(setMaxResendOTPReached(data)),
        set2FAviaOTP: (data) => dispatch(set2FAviaOTP(data)),
        setDefaultError: (data) => dispatch(setDefaultError(data)),
        userTriggeredLeave: (data) => dispatch(userTriggeredLeave(data)),
        setStopQueryPolling: (data) => dispatch(setStopQueryPolling(data)),
        resetAllData: () => dispatch(resetAllData()),
        setIsLoading: (data) => dispatch(setIsLoading(data)),
        setIsVerifying: (data) => dispatch(setIsVerifying(data)),
        setSessionExpired: (data) => dispatch(setSessionExpired(data)),
        setIsGuest: (data) => dispatch(setIsGuest(data)),
        setIsSkipLogin: (data) => dispatch(setIsSkipLogin(data)),
        updateTopUpData: (data) => dispatch(updateTopUpData(data)),
    });

    return connect(mapStateToProps, mapDispatchToProps)(MainWrapper);
};

export default connectPage;